import { createReducer, on } from '@ngrx/store';
import { MyPlatform, MyPlatformsActions } from '../actions/my-platforms.actions';

export interface MyPlatformsState {
  platforms: MyPlatform[];
  loading: boolean;
  error: any;
}

export const initialMyPlatformsState: MyPlatformsState = {
  platforms: [],
  loading: false,
  error: null,
};

export const myPlatformsReducer = createReducer(
  initialMyPlatformsState,
  on(MyPlatformsActions.loadMyPlatforms, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MyPlatformsActions.loadMyPlatformsSuccess, (state, { platforms }) => ({
    ...state,
    platforms,
    loading: false,
    error: null,
  })),
  on(MyPlatformsActions.loadMyPlatformsFailure, (state, { error }) => ({
    ...state,
    platforms: [],
    loading: false,
    error,
  })),
);
